var $23b4f990ce23d252$exports = {};
$23b4f990ce23d252$exports = {
    "endTime": `Kon\u{10D}ni \u{10D}as`,
    "startTime": `Za\u{10D}etni \u{10D}as`,
    "time": `\u{10C}as`
};


export {$23b4f990ce23d252$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
